import { render, staticRenderFns } from "./praise.vue?vue&type=template&id=1443e0de&"
import script from "./praise.vue?vue&type=script&lang=js&"
export * from "./praise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports